import React, { useState, useEffect, useRef, useCallback } from "react";
// import { customerSearch } from "config/Services";
import { customerSearchV2Api } from "config/Services";
import "./index.css";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";

const CHANNEL = "pos-dual-screen";

function getStoreName() {
  try {
    const d = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
    return d?.orgName || d?.locationName || d?.branchName || d?.firstName || "Pallet POS";
  } catch {
    return "Pallet POS";
  }
}

function fmt(n) {
  return getStoreCurrencySymbol() + (Number(n) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
}

function fmtPhone(p) {
  if (!p) return "";
  return p?.length <= 5 ? p : p.slice(0, 5) + " " + p.slice(5);
}

// ── Idle Screen ─────────────────────────────────────────────────────────────
function IdleScreen({ storeName, onToggleTouch }) {
  return (
    <div className="dsd-screen dsd-idle">
      <div className="dsd-idle-orb dsd-idle-orb-1" />
      <div className="dsd-idle-orb dsd-idle-orb-2" />
      <div className="dsd-idle-orb dsd-idle-orb-3" />
      <div className="dsd-idle-content">
        <div className="dsd-idle-avatar">
          {storeName?.charAt(0).toUpperCase()}
        </div>
        <h1 className="dsd-idle-store">{storeName}</h1>
        <p className="dsd-idle-tagline">Welcome — your order will appear here</p>
        <div className="dsd-idle-dots">
          <span /><span /><span />
        </div>
      </div>
      <button className="dsd-idle-mode-btn" onClick={onToggleTouch} title="Switch mode">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="5" y="2" width="14" height="20" rx="2" />
          <path d="M12 18h.01" />
        </svg>
        Switch to Touch Mode
      </button>
    </div>
  );
}

// ── Phone Entry Screen ───────────────────────────────────────────────────────
function PhoneScreen({ phone, phoneState, foundCustomer, onKey, storeName, onSwitchDisplay }) {
  const KEYS = ["1","2","3","4","5","6","7","8","9","Skip","0","⌫"];

  return (
    <div className="dsd-screen dsd-phone">
      <div className="dsd-phone-header">
        <p className="dsd-phone-store">{storeName}</p>
        <h2 className="dsd-phone-title">Enter your mobile number</h2>
        <p className="dsd-phone-sub">Earn and redeem loyalty points on this order</p>
      </div>

      <div className="dsd-phone-display-wrap">
        {phone?.length === 0 ? (
          <span className="dsd-phone-placeholder">_ _ _ _ _  _ _ _ _ _</span>
        ) : (
          <span className="dsd-phone-value">{fmtPhone(phone)}</span>
        )}
        {phoneState === "searching" && <div className="dsd-phone-searching" />}
      </div>

      {phoneState === "found" && foundCustomer && (
        <div className="dsd-phone-result dsd-phone-result-found">
          <div className="dsd-phone-result-avatar">
            {foundCustomer?.name?.charAt(0)?.toUpperCase()}
          </div>
          <div className="dsd-phone-result-info">
            <p className="dsd-phone-result-name">Welcome back, {foundCustomer?.name?.split(" ")[0]}!</p>
            <p className="dsd-phone-result-pts">
              {foundCustomer?.loyaltyPoints > 0
                ? `${foundCustomer?.loyaltyPoints} loyalty points available`
                : "Loyalty member"}
            </p>
          </div>
        </div>
      )}

      {phoneState === "not-found" && (
        <div className="dsd-phone-result dsd-phone-result-new">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 0 0-16 0"/>
            <line x1="12" y1="4" x2="12" y2="4.01"/><line x1="12" y1="10" x2="12" y2="16"/>
          </svg>
          <p>New customer — you'll earn points on this order!</p>
        </div>
      )}

      {/* After lookup result — show Continue button so user can proceed */}
      {(phoneState === "found" || phoneState === "not-found") && (
        <button
          className="dsd-phone-continue-btn"
          onClick={() => onKey("Skip")}
        >
          Continue to Order →
        </button>
      )}

      {phoneState !== "found" && phoneState !== "not-found" && (
        <div className="dsd-keypad">
          {KEYS.map((k) => (
            <button
              key={k}
              className={`dsd-key${k === "Skip" ? " dsd-key-skip" : ""}${k === "⌫" ? " dsd-key-back" : ""}`}
              onClick={() => onKey(k)}
              disabled={phoneState === "searching"}
            >
              {k}
            </button>
          ))}
        </div>
      )}

      <button className="dsd-idle-mode-btn" onClick={onSwitchDisplay} title="Switch to display mode">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/>
          <line x1="12" x2="12" y1="17" y2="21"/>
        </svg>
        Display Only Mode
      </button>
    </div>
  );
}

// ── Cart Screen ──────────────────────────────────────────────────────────────
function CartScreen({ cart, customer, storeName }) {
  const discount = Number(cart.discount) || 0;
  const coupon = parseFloat(cart.coupon) > 0 ? parseFloat(cart.coupon) : 0;
  const totalDiscount = discount + coupon;

  return (
    <div className="dsd-screen dsd-cart">
      <div className="dsd-cart-topbar">
        <div className="dsd-cart-topbar-left">
          <span className="dsd-live-badge">● LIVE</span>
          <span className="dsd-cart-count">
            {cart?.items?.length} item{cart?.items?.length !== 1 ? "s" : ""}
          </span>
        </div>
        {customer?.name && (
          <div className="dsd-cart-customer-pill">
            <span className="dsd-cart-customer-av">{customer?.name?.charAt(0)?.toUpperCase()}</span>
            <span className="dsd-cart-customer-name">{customer?.name}</span>
            {Number(customer?.loyaltyPoints) > 0 && (
              <span className="dsd-cart-loyalty-chip">
                {customer?.loyaltyPoints} pts
              </span>
            )}
          </div>
        )}
        <span className="dsd-cart-store">{storeName}</span>
      </div>

      <div className="dsd-cart-body">
        {/* Items column */}
        <div className="dsd-cart-items-col">
          <div className="dsd-cart-items-list">
            {cart?.items?.map((item, i) => (
              <div key={i} className="dsd-cart-item">
                <div className="dsd-cart-item-num">{i + 1}</div>
                <div className="dsd-cart-item-name">{item?.name}</div>
                <div className="dsd-cart-item-qty">× {item?.qty}</div>
                <div className="dsd-cart-item-price">
                  {fmt(item?.total ?? (item?.price * item?.qty))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary column */}
        <div className="dsd-cart-summary-col">
          <div className="dsd-cart-summary-card">
            <div className="dsd-summary-title">Order Summary</div>

            <div className="dsd-summary-row">
              <span>Subtotal</span>
              <span>{fmt(cart?.subtotal)}</span>
            </div>
            <div className="dsd-summary-row">
              <span>GST</span>
              <span>{fmt(cart?.tax)}</span>
            </div>
            {totalDiscount > 0 && (
              <div className="dsd-summary-row dsd-summary-row-discount">
                <span>Discount</span>
                <span>− {fmt(totalDiscount)}</span>
              </div>
            )}
            {cart?.coupon && parseFloat(cart?.coupon) > 0 && (
              <div className="dsd-summary-row dsd-summary-row-discount">
                <span>Coupon</span>
                <span>− {fmt(cart?.coupon)}</span>
              </div>
            )}

            <div className="dsd-summary-divider" />

            <div className="dsd-summary-total">
              <span>Total</span>
              <span>{fmt(cart?.total)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Success Screen ───────────────────────────────────────────────────────────
function SuccessScreen({ successData }) {
  const name = successData?.customerName?.split(" ")[0] || "";
  return (
    <div className="dsd-screen dsd-success">
      <div className="dsd-success-glow" />
      <div className="dsd-success-ring">
        <svg className="dsd-success-svg" viewBox="0 0 52 52">
          <circle className="dsd-success-circle" cx="26" cy="26" r="24" fill="none" strokeWidth="2.5" />
          <path className="dsd-success-check" fill="none" strokeWidth="3"
            strokeLinecap="round" strokeLinejoin="round" d="M14 27l8 8 16-16" />
        </svg>
      </div>
      <h2 className="dsd-success-title">
        {name ? `Thank you, ${name}!` : "Payment Successful!"}
      </h2>
      <p className="dsd-success-sub">Your payment has been confirmed.</p>
      {successData?.total > 0 && (
        <div className="dsd-success-amount">{fmt(successData?.total)}</div>
      )}
      <div className="dsd-success-timer-wrap">
        <div className="dsd-success-timer-bar"><div className="dsd-success-timer-fill" /></div>
        <p className="dsd-success-timer-label">Returning to home screen…</p>
      </div>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function DualScreenDisplay() {
  const params = new URLSearchParams(window.location.search);
  const [touchMode, setTouchMode] = useState(params.get("mode") === "touch");
  const [screen, setScreen] = useState(params.get("mode") === "touch" ? "phone" : "idle");
  const [cart, setCart] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [phone, setPhone] = useState("");
  const [phoneState, setPhoneState] = useState("idle"); // idle | searching | found | not-found
  const [foundCustomer, setFoundCustomer] = useState(null);
  const [successData, setSuccessData] = useState(null);

  const ch = useRef(null);
  const successTimer = useRef(null);
  const storeName = getStoreName();

  const resetToHome = useCallback((isTouchMode) => {
    setSuccessData(null);
    setCart(null);
    setCustomer(null);
    setPhone("");
    setPhoneState("idle");
    setFoundCustomer(null);
    setScreen(isTouchMode ? "phone" : "idle");
  }, []);

  // BroadcastChannel
  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL);
    ch.current = channel;
    channel.postMessage({ type: "screen_ready" });

    channel.onmessage = ({ data: msg }) => {
      if (!msg?.type) return;

      if (msg?.type === "cart_update") {
        const hasItems = (msg?.items || []).length > 0;
        const newCart = hasItems ? msg : null;
        setCart(newCart);
        if (msg?.customerName) {
          setCustomer({ name: msg?.customerName, mobile: msg?.customerMobile, loyaltyPoints: msg?.loyaltyPoints || 0 });
        } else if (!hasItems) {
          setCustomer(null);
        }
        setScreen((prev) => {
          if (prev === "success") return "success";
          if (hasItems) return "cart";
          return touchMode ? "phone" : "idle";
        });
      }

      if (msg?.type === "payment_success") {
        setSuccessData({ customerName: msg?.customerName, total: msg?.total, orderId: msg?.orderId });
        setScreen("success");
        setCart(null);
        clearTimeout(successTimer.current);
        successTimer.current = setTimeout(() => resetToHome(touchMode), 7000);
      }
    };

    return () => {
      channel.close();
      ch.current = null;
      clearTimeout(successTimer.current);
    };
  }, [touchMode, resetToHome]);

  // localStorage hydration — reads current cart state immediately on mount so the display
  // works even when the BroadcastChannel handshake is missed (e.g. display opened while
  // POS already has items, or opened in a new tab before screen_ready reply arrives).
  // Also listens to `storage` events for real-time updates as a BroadcastChannel fallback.
  useEffect(() => {
    const apply = (msg) => {
      if (!msg?.type) return;
      if (msg?.type === "cart_update") {
        const hasItems = (msg?.items || []).length > 0;
        setCart(hasItems ? msg : null);
        if (msg?.customerName) {
          setCustomer({ name: msg?.customerName, mobile: msg?.customerMobile, loyaltyPoints: msg?.loyaltyPoints || 0 });
        } else if (!hasItems) {
          setCustomer(null);
        }
        setScreen((prev) => {
          if (prev === "success") return "success";
          return hasItems ? "cart" : "idle";
        });
      }
    };

    // Hydrate immediately from localStorage
    try {
      const raw = localStorage.getItem("dualScreenCart");
      if (raw) apply(JSON.parse(raw));
    } catch (_) {}

    // Real-time updates via storage events (fires in other top-level tabs when Cart.js writes)
    const onStorage = (e) => {
      if (e?.key !== "dualScreenCart" || !e?.newValue) return;
      try { apply(JSON.parse(e?.newValue)); } catch (_) {}
    };
    window.addEventListener("storage", onStorage);

    // Polling fallback — storage events don't fire when the writer is inside an iframe
    // (e.g. Replit preview pane). Poll every 1s as a reliable safety net.
    let lastRaw = localStorage.getItem("dualScreenCart");
    const poll = setInterval(() => {
      try {
        const raw = localStorage.getItem("dualScreenCart");
        if (raw && raw !== lastRaw) {
          lastRaw = raw;
          apply(JSON.parse(raw));
        }
      } catch (_) {}
    }, 1000);

    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(poll);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Keypad handler
  const handleKey = useCallback((key) => {
    if (key === "⌫") {
      setPhone((p) => p.slice(0, -1));
      setPhoneState("idle");
      setFoundCustomer(null);
      return;
    }
    if (key === "Skip") {
      ch.current?.postMessage({ type: "phone_skipped" });
      setPhone("");
      setPhoneState("idle");
      setFoundCustomer(null);
      return;
    }
    setPhone((prev) => {
      if (prev?.length >= 10) return prev;
      const next = prev + key;
      if (next?.length === 10) {
        setPhoneState("searching");
        const locId = localStorage.getItem("locId");
        const orgId = localStorage.getItem("orgId");
        /*
        customerSearch({ mobile: next, locId })
          .then((res) => {
            const data = res?.data?.data;
            const cust = Array.isArray(data) ? data[0] : data;
            if (cust && (cust?.name || cust?.firstName)) {
              const info = {
                name: cust?.name || cust?.firstName || "",
                mobile: next,
                loyaltyPoints: cust?.totalLoyaltyPoints ?? cust?.loyaltyPoints ?? 0,
              };
              setFoundCustomer(info);
              setCustomer(info);
              setPhoneState("found");
              ch.current?.postMessage({ type: "customer_found", ...info });
            } else {
              setFoundCustomer(null);
              setPhoneState("not-found");
              ch.current?.postMessage({ type: "customer_not_found", mobile: next });
            }
          })
        */
        customerSearchV2Api({ organizationId: orgId, search: next, pageNumber: 0, pageSize: 1 })
          .then((res) => {
            const cust = res?.data?.customers?.[0] || {};
            if (cust && cust?.name) {
              const info = {
                name: cust?.name || "",
                mobile: next,
                loyaltyPoints: cust?.totalLoyaltyPoints ?? cust?.loyaltyPoints ?? 0,
              };
              setFoundCustomer(info);
              setCustomer(info);
              setPhoneState("found");
              ch.current?.postMessage({ type: "customer_found", ...info });
            } else {
              setFoundCustomer(null);
              setPhoneState("not-found");
              ch.current?.postMessage({ type: "customer_not_found", mobile: next });
            }
          })
          .catch(() => {
            setFoundCustomer(null);
            setPhoneState("not-found");
          });
      }
      return next;
    });
  }, []);

  const switchToTouch = () => {
    setTouchMode(true);
    setScreen("phone");
  };

  const switchToDisplay = () => {
    setTouchMode(false);
    setScreen(cart ? "cart" : "idle");
  };

  return (
    <div className="dsd-root">
      {screen === "idle"    && <IdleScreen storeName={storeName} onToggleTouch={switchToTouch} />}
      {screen === "phone"   && (
        <PhoneScreen
          phone={phone}
          phoneState={phoneState}
          foundCustomer={foundCustomer}
          onKey={handleKey}
          storeName={storeName}
          onSwitchDisplay={switchToDisplay}
        />
      )}
      {screen === "cart"    && <CartScreen cart={cart} customer={customer} storeName={storeName} />}
      {screen === "success" && <SuccessScreen successData={successData} />}
    </div>
  );
}
